<template>
  <div class="home" :class="`home--${this.$route.query.site}`">
    <Lobby />
    <div class="ribbon"
      @click="ribbonCTA">
      <div class="ribbon__content"
        :class="{'ribbon__content-1': this.$route.name === 'home-money'}"
        :style="ribbonBg">
      </div>
      <span v-if="this.$route.name !== 'home-money'">
        <template v-if="this.$route.query.site">
          {{$t(`ribbon.disclaimer-${this.$route.query.site}`)}}
        </template>
        <template v-else>
          {{$t(`ribbon.disclaimer`)}}
        </template>
      </span>
    </div>
    <div class="footer">
      <div class="footer__content" v-if="!hideFooter">
        <span class="link"
          @click="getArticeLink()">
          {{$t('footer.terms-conditions')}}
        </span>
        <span class="link"
          @click="getArticeLink()">
          {{$t('footer.privacy-policy')}}
        </span>
        <span class="link"
          @click="getArticeLink('contact')"
          v-if="this.$route.query.contactFooter">
          {{$t('footer.contact')}}
        </span>
        <span class="back-link" v-if="this.$route.query.addBackLink">
          Powered by: <a class="link" href="https://casinogames.guide" target="_parent">casinogames.guide</a>
        </span>
      </div>
    </div>
    <SubscribeNewsletter
      :active="isFormActive"
      @onClose="closeForm"
      @onSave="placeSelectionConfirm" />
    <Alert
      :msg="alertText()"
      :active="isAlertActive"
      @onClose="closeAlert"
     />
  </div>
</template>

<script>
import Lobby from '../components/Lobby.vue'
import SubscribeNewsletter from '../components/SubscribeNewsletter.vue'
import Alert from '../components/Alert.vue'

export default {
  name: 'home',
  components: {
    Lobby,
    SubscribeNewsletter,
    Alert
  },
  data () {
    return {
      isFormActive: false,
      isAlertActive: false
    }
  },
  methods: {
    alertText () {
      return this.$t('newsletter.success')
    },
    closeAlert () {
      this.isAlertActive = false
    },

    placeSelectionConfirm () {
      this.isFormActive = false
      this.isAlertActive = true
    },

    closeForm () {
      this.isFormActive = false
    },

    getArticeLink (item) {
      if (!item) {
        item = 'privacy-policy'
      }
      let redirect = {
        name: 'article',
        query: { ...this.$route.query },
        params: {
          lang: this.$root.$i18n.locale || 'de',
          article: item
        }
      }
      this.$router.push(redirect)
    },

    ribbonCTA () {
      if (this.$route.name !== 'home-money') {
        this.isFormActive = true
      } else {
        let gclid = this.$route.query.gclid || ''
        let siteId = this.$route.query.siteId || ''
        let btag = this.$route.query.btag || ''
        let adId = this.$route.query.adId || '185'
        let aff = this.$route.query.aff
        let redirectUrl = ''
        if (aff) {
          let affLink = this.$t(`general.affiliate-link-${aff}`)
          redirectUrl = `${affLink}&c=${gclid}`
        } else {
          redirectUrl = `https://wlwetten.adsrv.eacdn.com/C.ashx?btag=${btag}&affid=453&siteid=${siteId}&adid=${adId}&c=${gclid}`
        }
        window.open(
          redirectUrl,
          `_blank`
        )
      }
    }
  },
  computed: {
    hideFooter () {
      return this.$route.query.hideFooter === 'true'
    },
    ribbonBg () {
      let locale = this.$root.$i18n.locale
      let bg = `url('/images/lp-ribbon-${locale}-0.jpg')`
      if (this.$route.query.site) {
        bg = `url('/images/lp-ribbon-${locale}-0-${this.$route.query.site}.jpg')`
      }
      if (this.$route.name === 'home-money') {
        bg = `url('/images/lp-ribbon-${locale}-1.jpg')`
        if (this.$route.query.aff) {
          bg = `url('/images/lp-ribbon-${locale}-1-${this.$route.query.aff}.jpg')`
        }
      }
      return {
        'background-image': bg
      }
    }
  }
}
</script>

<style lang="stylus">
.footer
  height 180px
  background #3c3c44
  padding-top 20px
  margin-top 20px
  &__content
    width 90%
    max-width 1024px
    margin 0 auto
    .link
      color #fff !important
      font-size 12px
      border-right 1px solid #797979
      padding 0px 10px
      cursor pointer
      text-decoration underline
      &:hover
        text-decoration none
      &:last-of-type
        border 0px
    .back-link
      margin-left 10px
      .link
        padding-left 5px
      color #fff
      font-size 12px

.ribbon
  background #fff
  position fixed
  bottom 0
  width 100%
  text-align center
  span
    width 90%
    margin 0 auto
    margin-top 5px
    margin-bottom 10px
    display block
    font-size 10px
  &__content
    cursor pointer
    width 90%
    background-position center center
    margin 0 auto
    max-width 1024px
    height 60px
    background-size 90%

.home
  &--socialcasino
    background #3d6098
    .lobby__cta .button
      background #ff8400
    .footer,
    .lobby__load-more .button
      background #213159
  &--topcasinoslots
    background #700f28
    .lobby__cta .button
      background #31AFD4
    .footer,
    .lobby__load-more .button
      background #5E0035
  &--playslotsonline
    background #56637c
  &--gamesparadise
    background #111
    .lobby__banner
      margin-bottom 0

@media (max-width: 1024px)
  .ribbon
    &__content
      background-size 120%

@media (max-width: 760px)
  .ribbon
    &__content
      height 50px
      background-size 200%

@media (max-width: 760px)
  .ribbon
    &__content-1
      height 30px
      background-size 130%

</style>
